/**
 * restock-label.js
 *
 * Recalculeaza in browser textul etichetei <restock-label> ("Epuizat. Disponibil: Vi").
 *
 * Liquid calculeaza deja ziua la randare, ca textul sa fie corect si fara JavaScript.
 * Problema e ca paginile pot fi servite din cache: o pagina randata joi ar continua sa
 * spuna "Vi" si sambata. Scriptul asta recalculeaza aceeasi regula pe client, folosind
 * ora din fusul magazinului, si corecteaza textul daca s-a schimbat ziua.
 *
 * Fiind un custom element, functioneaza automat si pe cardurile injectate ulterior
 * (filtre, scroll infinit, cautare predictiva, quick view).
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('restock-label')) return;

  var SHOP_TZ = 'Europe/Bucharest';
  var ABBR = ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'];
  var WEEKDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  /* Data si ora curenta in fusul magazinului, indiferent de fusul vizitatorului. */
  function shopNow() {
    var d = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: SHOP_TZ,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hour12: false
      }).formatToParts(d);

      var get = function (type) {
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === type) return parts[i].value;
        }
        return '';
      };

      var wday = WEEKDAY[get('weekday')];
      var hour = parseInt(get('hour'), 10);
      var ymd = get('year') + '-' + get('month') + '-' + get('day');

      if (wday !== undefined && !isNaN(hour)) {
        return { wday: wday, hour: hour, ymd: ymd };
      }
    } catch (e) {
      /* Intl indisponibil sau fus necunoscut: cadem pe ora locala. */
    }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    return {
      wday: d.getDay(),
      hour: d.getHours(),
      ymd: d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
    };
  }

  function intAttr(el, name, fallback) {
    var raw = parseInt(el.getAttribute(name), 10);
    return isNaN(raw) ? fallback : raw;
  }

  function computeDay(el, now) {
    var max = intAttr(el, 'data-max', 7);
    var cutoff = intAttr(el, 'data-cutoff', 23);

    /* 1. Data exacta setata pe produs. */
    var fixed = (el.getAttribute('data-date') || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(fixed)) {
      var target = new Date(fixed + 'T00:00:00');
      var today = new Date(now.ymd + 'T00:00:00');
      var ahead = Math.round((target - today) / 86400000);
      if (ahead >= 0 && ahead <= max) return ABBR[target.getDay()];
    }

    /* 2. Zilele saptamanale de aprovizionare. */
    var days = (el.getAttribute('data-days') || '')
      .split(',')
      .map(function (v) { return parseInt(v, 10); })
      .filter(function (v) { return !isNaN(v) && v >= 0 && v <= 6; });

    if (!days.length) return '';

    for (var step = 0; step <= max; step++) {
      if (step === 0 && now.hour >= cutoff) continue;
      var probe = (now.wday + step) % 7;
      if (days.indexOf(probe) !== -1) return ABBR[probe];
    }
    return '';
  }

  class RestockLabel extends HTMLElement {
    connectedCallback() {
      const format = this.getAttribute('data-format') || 'Epuizat. Disponibil: [zi]';
      const fallback = this.getAttribute('data-fallback') || 'Stoc epuizat';
      const day = computeDay(this, shopNow());
      const text = day ? format.replace('[zi]', day) : fallback;

      if (this.textContent.trim() !== text) this.textContent = text;
    }
  }

  customElements.define('restock-label', RestockLabel);
})();
